import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Row, Col, Collapse } from "antd";

import colors from "../../../colors";
import TextIcon from "../../app/generic/textIcon";

const { Panel } = Collapse;

const ImportInstructions = ({ filePrefix, children }) => {
  const intl = useIntl();
  return (
    <Row gutter={[0, 100]}>
      <Col>
        <Row type="flex" align="middle" justify="space-around" gutter={[0, 50]}>
          <Col span={6} className="center">
            <Link
              download
              target="_blank"
              className="external-link"
              to={`/files/${filePrefix}_template_${intl.locale.substring(
                0,
                2
              )}.xlsx`}
            >
              <TextIcon
                type="file-excel"
                color={colors.RED}
                text={intl.formatMessage(
                  {
                    id: "import.format",
                    defaultMessage: "Šablona ve formátu {type}",
                  },
                  { type: "xlsx" }
                )}
                title={intl.formatMessage({
                  id: "import.download",
                  defaultMessage: "Klikněte pro stažení",
                })}
              />
            </Link>
          </Col>
          <Col span={6} className="center">
            <Link
              download
              target="_blank"
              className="external-link"
              to={`/files/${filePrefix}_template_${intl.locale.substring(
                0,
                2
              )}.csv`}
            >
              <TextIcon
                type="file"
                color={colors.RED}
                text={intl.formatMessage(
                  {
                    id: "import.format",
                    defaultMessage: "Šablona ve formátu {type}",
                  },
                  { type: "csv" }
                )}
                title={intl.formatMessage({
                  id: "import.download",
                  defaultMessage: "Klikněte pro stažení",
                })}
              />
            </Link>
          </Col>
        </Row>
        <Row gutter={[0, 50]}>
          <Col>
            <Collapse>
              <Panel
                key="1"
                forceRender
                header={intl.formatMessage({
                  id: "import.dataFormat",
                  defaultMessage: "Datový formát",
                })}
              >
                {children}
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ImportInstructions;
